import React from 'react';

const QuoteIcon: React.FC = () => (
  <svg
    width='112'
    height='88'
    viewBox='0 0 112 88'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='112' height='88' fill='black' />
    <path
      d='M78.1571 59.2207C83.1891 53.7593 82.6825 46.746 82.6665 46.666V25.3327C82.6665 24.6254 82.3855 23.9472 81.8854 23.4471C81.3853 22.947 80.707 22.666 79.9998 22.666H63.9998C61.0585 22.666 58.6665 25.058 58.6665 27.9993V46.666C58.6665 47.3733 58.9474 48.0515 59.4475 48.5516C59.9476 49.0517 60.6259 49.3327 61.3331 49.3327H69.5411C69.4848 50.651 69.0909 51.9329 68.3971 53.0553C67.0425 55.1913 64.4905 56.65 60.8078 57.386L58.6665 57.8127V65.3327H61.3331C68.7545 65.3327 74.4158 63.2767 78.1571 59.2207ZM48.8051 59.2207C53.8398 53.7593 53.3305 46.746 53.3145 46.666V25.3327C53.3145 24.6254 53.0335 23.9472 52.5334 23.4471C52.0333 22.947 51.355 22.666 50.6478 22.666H34.6478C31.7065 22.666 29.3145 25.058 29.3145 27.9993V46.666C29.3145 47.3733 29.5954 48.0515 30.0955 48.5516C30.5956 49.0517 31.2739 49.3327 31.9811 49.3327H40.1891C40.1328 50.651 39.7389 51.9329 39.0451 53.0553C37.6905 55.1913 35.1385 56.65 31.4558 57.386L29.3145 57.8127V65.3327H31.9811C39.4025 65.3327 45.0638 63.2767 48.8051 59.2207Z'
      fill='white'
    />
  </svg>
);

export default QuoteIcon;
